import { useTranslation } from 'react-i18next';

import {
	TooltipContent,
	TooltipPortal,
	TooltipProvider,
	TooltipRoot,
	TooltipTrigger
} from '@/components/Tooltip';
import IconClose from '@/icons/close.svg';
import { IconButton } from '@/pages/PdfEditor/Sidebar/PagesModal/components';
import { cn } from '@/utils';

function TooltipLarge({
	classNameDescription,
	children,
	handleClose,
	hasCloseButton,
	title,
	description,
	actionText,
	tooltipContentProps,
	side,
	sideOffset,
	delayDuration,
	disabled,
	disableHoverableContent,
	container,
	onClick = () => {},
	...props
}) {
	const { t } = useTranslation();

	if (disabled || (!title && !description)) {
		return children;
	}

	function handleActionClick(e) {
		e.stopPropagation();
		if (document.activeElement) document.activeElement.blur();
		onClick(e);
	}

	return (
		<TooltipProvider
			disableHoverableContent={disableHoverableContent}
			delayDuration={100}
		>
			<TooltipRoot {...props}>
				<TooltipTrigger asChild>{children}</TooltipTrigger>
				<TooltipPortal container={container}>
					<TooltipContent
						side={side}
						sideOffset={sideOffset}
						{...tooltipContentProps}
						className="relative max-w-[249px] border border-grey-200 bg-white p-4"
					>
						{hasCloseButton && (
							<IconButton
								aria-label={t('common.close')}
								className="absolute right-4 top-4"
								onClick={handleClose}
								variant="ghost"
							>
								<IconClose
									aria-hidden
									className="size-5 text-grey-500"
								/>
							</IconButton>
						)}
						{title && (
							<p className="text-sm font-semibold leading-6 text-black">
								{title}
							</p>
						)}
						{description && (
							<p
								className={cn(
									'mt-2 text-xs font-normal leading-5 text-gray-500',
									classNameDescription
								)}
							>
								{description}
							</p>
						)}
						{actionText && (
							<button
								type="button"
								className="pe-2 pt-2 text-xs font-semibold text-red"
								onClick={handleActionClick}
							>
								{actionText}
							</button>
						)}
					</TooltipContent>
				</TooltipPortal>
			</TooltipRoot>
		</TooltipProvider>
	);
}

export default TooltipLarge;
